import React from 'react';
import { UsersIcon, CalendarIcon, BarChartIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
export function RoleSelect() {
  const {
    setRole
  } = useAuth();
  const navigate = useNavigate();
  const handleRoleSelect = (selectedRole: 'instructor' | 'planner' | 'manager') => {
    setRole(selectedRole);
    navigate('/dashboard');
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50" data-id="element-276">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow" data-id="element-277">
        <div className="text-center" data-id="element-278">
          <div className="mx-auto h-20 w-auto" data-id="element-279">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vML8uoGZWQx9SMCPgucRCS/VVGN_Logo_Dark.png" alt="VVGN Logo" className="h-full mx-auto" data-id="element-280" />
          </div>
          <h2 className="mt-4 text-2xl font-bold text-gray-900" data-id="element-281">
            Select Your Role
          </h2>
          <p className="mt-2 text-sm text-gray-600" data-id="element-282">
            Choose your role to access the appropriate dashboard
          </p>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-4" data-id="element-283">
          <button onClick={() => handleRoleSelect('planner')} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent transition" data-id="element-284">
            <div className="flex items-center" data-id="element-285">
              <div className="bg-blue-100 p-3 rounded-lg" data-id="element-286">
                <CalendarIcon className="h-6 w-6 text-blue-600" data-id="element-287" />
              </div>
              <div className="ml-4 text-left" data-id="element-288">
                <h3 className="text-sm font-medium text-gray-900" data-id="element-289">Planner</h3>
                <p className="text-xs text-gray-500" data-id="element-290">
                  Schedule and manage training sessions
                </p>
              </div>
            </div>
          </button>
          <button onClick={() => handleRoleSelect('manager')} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent transition" data-id="element-291">
            <div className="flex items-center" data-id="element-292">
              <div className="bg-purple-100 p-3 rounded-lg" data-id="element-293">
                <BarChartIcon className="h-6 w-6 text-purple-600" data-id="element-294" />
              </div>
              <div className="ml-4 text-left" data-id="element-295">
                <h3 className="text-sm font-medium text-gray-900" data-id="element-296">Manager</h3>
                <p className="text-xs text-gray-500" data-id="element-297">
                  Oversee operations and view reports
                </p>
              </div>
            </div>
          </button>
          <button onClick={() => handleRoleSelect('instructor')} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent transition" data-id="element-298">
            <div className="flex items-center" data-id="element-299">
              <div className="bg-green-100 p-3 rounded-lg" data-id="element-300">
                <UsersIcon className="h-6 w-6 text-green-600" data-id="element-301" />
              </div>
              <div className="ml-4 text-left" data-id="element-302">
                <h3 className="text-sm font-medium text-gray-900" data-id="element-303">
                  Instructor
                </h3>
                <p className="text-xs text-gray-500" data-id="element-304">
                  View assigned trainings and student information
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>;
}